
import React, { useRef, useState, useEffect } from 'react';
import _ from 'underscore'

    
const max_pull_height = 120


const LoadOnScroll = ({ children, refreshContent, loadMoreContent,  startHidden, disabled }) => {

    const scrollingContainer = useRef(0);
    const refresherStatus = useRef('idle');
    const loadMoreStatus = useRef('idle');
    const scrolledTimeout = useRef(0);

    const touchStartY = useRef(0);

    const [, forceUpdate] = useState(0);
    const pullHeight = useRef(0);

    const [loadSpin, setLoadSpin] = useState(0);
    
    const startSpinning = () => {
        const interval = 25
        let spin = 0
        const spinCallback = async () => {
            setLoadSpin(spin)
            spin += 6
            if (refresherStatus.current !== 'idle' ) {
                setTimeout(spinCallback, interval)
            } else {
                setLoadSpin(0)
            }
        }
        setTimeout(spinCallback, interval)
    }
    
    const refreshContentWrapped = async (initial=false) => {
        if (refresherStatus.current === 'loading') return;
        refresherStatus.current = 'loading';
        startSpinning()
        await refreshContent(initial);
        triggerHidingRefresher();
    }
    const loadMoreContentWrapped = async () => {
        if (loadMoreStatus.current === 'loading') return;
        loadMoreStatus.current = 'loading'
        await loadMoreContent()
        loadMoreStatus.current = 'idle'
    }

  
    const triggerHidingRefresher = (set_idle=true) => {
        refresherStatus.current = 'hiding';
        const animateDown = () => {
            if (!scrollingContainer.current) 
                return
            
            pullHeight.current -= 3
            if (pullHeight.current <= 0) {
                pullHeight.current = 0
            }
            forceUpdate(prev => prev + 1);
            if (pullHeight.current === 0) {
                if (set_idle) {
                    refresherStatus.current = 'idle';
                }
            } else {
                setTimeout(animateDown, 0)
            }
        }
        animateDown()
    }

    
    useEffect(() => {
        const commonScroll = (deltaY) => {
            if (pullHeight.current >= max_pull_height) {
                pullHeight.current = max_pull_height;
                refreshContentWrapped();
            }
            forceUpdate(prev => prev + 1);
    
            clearTimeout(scrolledTimeout.current);
            if (refresherStatus.current !== 'loading') {
                scrolledTimeout.current = setTimeout(() => {
                    triggerHidingRefresher();
                }, 250);
            }
            if (deltaY > 0) {
                triggerHidingRefresher();
                // pullHeight.current = 0
                // refresherStatus.current = 'idle';
                // forceUpdate(prev => prev + 1);
            }
        }
        const handleWheel = (event) => {
            if (disabled) return;
            if (scrollingContainer.current?.scrollTop <= 0) {
                if (event.deltaY < 0) {
                    pullHeight.current -= event.deltaY
                }
                commonScroll(event.deltaY)
            }
        };
        window.addEventListener("wheel", handleWheel);

        const handleTouchStart = (event) => {
            if (disabled) return;
            touchStartY.current = event.touches[0].clientY;
        };
        
        const handleTouchMove = (event) => {
            if (disabled) return;
            const touchY = event.touches[0].clientY;
            const deltaY = touchStartY.current - touchY;
        
            if (scrollingContainer.current?.scrollTop <= 0) {
                if (deltaY < 0) {
                    pullHeight.current = -deltaY;
                }
                commonScroll(deltaY)
            }
        };
        
        const handleTouchEnd = () => {
            touchStartY.current = null;
        };
        
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        window.addEventListener("touchend", handleTouchEnd);

        
        const handleScroll = async (e) => {
            if (disabled) 
                return;
            if (scrollingContainer.current) {
                if (scrollingContainer.current.scrollTop + scrollingContainer.current.clientHeight >= scrollingContainer.current.scrollHeight) {
                    if (_.isFunction(loadMoreContent)) {
                        if (loadMoreStatus.current === 'idle') {
                            await loadMoreContentWrapped();
                        }
                    }
                }
            }
        }
        scrollingContainer.current?.addEventListener('scroll', handleScroll);
             

        return () => {
            window.removeEventListener("wheel", handleWheel);
            window.removeEventListener("touchend", handleWheel);
            //todo: compiler doesn't like this:
            scrollingContainer.current?.removeEventListener('scroll', handleScroll)
            
        };
    }, [disabled]);

    
    useEffect(() => {
        if (!startHidden) {
            pullHeight.current = max_pull_height
        }
        refreshContentWrapped(true)
    }, [])
    
    const spinner_render = (height, start_hidden=false) => {
        return }


    
    const refresher_render = (
        <div
            style={{
                ...(disabled ? {display: 'none'} : {}),
                ...({height: `${pullHeight.current}px`})
            }}
            className={`flex-shrink-0 flex flex-col items-center justify-center bg-transparent  `}
        >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                style={{ transform: `rotate(${loadSpin}deg)` }}
                className={`w-[26px] h-[26px]`}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                </svg>
        </div>
    )
    const scrollBoxHeight = scrollingContainer.current ? `${scrollingContainer.current}px` : '100%'
    
    return (
        <div className='App-content'>       
            <div 
                style={{height: scrollBoxHeight}}
                className={`App-scrollbox`} 
                ref={scrollingContainer}  
            >
                {refresher_render} 
                {children}
            </div>  
        </div>
    );
};

export default LoadOnScroll;